import React from "react";
import { Modal, Button } from "antd";
import { ToolOutlined } from "@ant-design/icons";
import "./MaintenanceModal.scss";
import CustomButton from "../ui/CustomButton/CustomButton";
import { useTranslation } from "react-i18next";

interface MaintenanceModalProps {
  open: boolean;
  onClose: () => void;
}

const MaintenanceModal: React.FC<MaintenanceModalProps> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} footer={null} closable={false} centered className="maintenance-modal">
      <div className="maintenance">
        <div className="maintenance__icon">
          <ToolOutlined style={{ fontSize: 48, color: "#FF8C42" }} />
        </div>

        <h2 className="maintenance__title">{t("MakingImprovementsTitle")}</h2>

        <p className="maintenance__text">{t("MakingImprovementsDesc")}</p>

        <p className="maintenance__thanks">{t("MakingImprovementsThanks")}</p>

        <CustomButton
          text={t("GotIt")}
          type={"button"}
          typeStyle={"fill"}
          functionOnClick={onClose}
          style={{
            maxWidth: "324px",
            margin: "0 auto",
          }}
        />
      </div>
    </Modal>
  );
};

export default MaintenanceModal;
